// extracted by mini-css-extract-plugin
export default {"webUpselling":"othYNrHackk1216uRiXR"};